import { useNotificationsCategories } from 'hooks/useNotificationsCategories';

import { useColumns } from 'data/tableData/catalogue/notificationsCategoriesColumns';

import { Table } from 'components/Table';

import * as S from './List.styles';

export function List(): React.ReactElement {
  const { categories, refetchCategories, isLoading } = useNotificationsCategories();
  const columns = useColumns(refetchCategories);

  return (
    <div>
      <S.CreateWrapper>
        <S.Create iconLeft="FiPlus" scale="lg" asLink to="new" motive="addNew">
          Add new Category
        </S.Create>
      </S.CreateWrapper>
      <Table
        tableName="notificationsCategories"
        isLoading={isLoading}
        columns={columns}
        data={categories}
      />
    </div>
  );
}
